export default __webpack_public_path__ + "static/media/fat-arrrow-green.8cad7eda.svg";